import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";
import { Link } from "react-router-dom";
import { useSpecialism } from "../contexts/SpecialismContext";

type Article = {
  id: string;
  title: string;
  summary: string;
};

interface ArticleListProps {
  searchTerm: string;
  articles?: Article[];
}

function getShortSummary(summary: string, wordLimit: number = 15): string {
  const words = summary.split(/\s+/);
  if (words.length <= wordLimit) return summary;
  return words.slice(0, wordLimit).join(" ") + "...";
}

const ArticleList: React.FC<ArticleListProps> = ({ searchTerm, articles }) => {
  const { specialismCode } = useSpecialism(); // <-- Get code from context
  const [allArticles, setAllArticles] = useState<Article[]>([]);

  useEffect(() => {
    if (!articles) {
      const fetchArticles = async () => {
        const querySnapshot = await getDocs(collection(db, "articles"));
        const articlesData: Article[] = [];
        querySnapshot.forEach((doc) => {
          articlesData.push({ id: doc.id, ...doc.data() } as Article);
        });
        setAllArticles(articlesData);
      };
      fetchArticles();
    }
  }, [articles]);

  const articlesToShow = articles ?? allArticles;
  const normalizedSearch = searchTerm.trim().toLowerCase();

  const filteredArticles = articlesToShow.filter(article =>
    article.title.toLowerCase().includes(normalizedSearch) ||
    article.summary.toLowerCase().includes(normalizedSearch)
  );

  function getShortText(summary: string): string {
    return getShortSummary(summary, 15);
  }
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: "14px",
        width: "100%",
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      {filteredArticles.length === 0 ? (
        <p style={{ textAlign: "center", color: "#888" }}>No articles found.</p>
      ) : (
        filteredArticles.map((article) => (
          <div
            key={article.id}
            style={{
              background: "#fff",
              borderRadius: "18px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              transition: "box-shadow 0.2s",
            }}
          >
            <Link
              to={`/${specialismCode}/${article.id}`} // <-- Use specialismCode here
              style={{
                textDecoration: "none",
                color: "#1976d2",
                fontWeight: "bold",
                fontSize: "1rem",
                marginBottom: "8px",
                transition: "color 0.2s",
              }}
            >
              {article.title}
            </Link>
            <div
              className="article-summary"
              style={{ fontSize: "1rem", color: "#444", fontFamily: "inherit" }}
              dangerouslySetInnerHTML={{ __html: getShortText(article.summary) }}
            />
          </div>
        ))
      )}
    </div>
  );
};

export default ArticleList;